import { render, staticRenderFns } from "./SwitchToggle.vue?vue&type=template&id=5ff56864&scoped=true&"
import script from "./SwitchToggle.vue?vue&type=script&lang=js&"
export * from "./SwitchToggle.vue?vue&type=script&lang=js&"
import style0 from "./SwitchToggle.vue?vue&type=style&index=0&id=5ff56864&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff56864",
  null
  
)

export default component.exports